/**
 * Per-browser record of the first-visit navigation hint, for visitors who have
 * no backend settings to keep it in: sample models, shared links, and either of
 * those embedded in an iframe. Logged-in users keep it in their user defaults.
 */

const NAVIGATION_HINT_STORAGE_KEY = "airteam_navigation_hint_seen";

/**
 * Whether this browser has already been shown the hint.
 *
 * Reports true when storage is unavailable -- blocked cookies, or a third-party
 * iframe that is refused storage -- so the hint is skipped rather than shown on
 * every visit when there is no way to remember it.
 * @returns {boolean}
 */
export const hasSeenNavigationHintLocally = () => {
  try {
    return localStorage.getItem(NAVIGATION_HINT_STORAGE_KEY) === "true";
  } catch {
    return true;
  }
};

/** Record the hint as shown in this browser. Best-effort. */
export const markNavigationHintSeenLocally = () => {
  try {
    localStorage.setItem(NAVIGATION_HINT_STORAGE_KEY, "true");
  } catch {
    // Storage refused: nothing to remember it in.
  }
};
